


































import { Component, Watch, Vue } from 'vue-property-decorator';
import storage from '../../utils/storage';
import dayjs from 'dayjs';
import checkLogin from '../../utils/checkLogin';
import Loading from '../../components/Loading.vue';
@Component({
  components: {
    Loading,
  },
})

export default class ZKDPDF extends Vue {
  private user: any;
  private dataJson: any = {
    PDFPath: '',
    letterPathArr: [],
    beforeLetterName: '',
    orderPath: '',
  };
  private spinning: boolean = false;
  private headers: any = {
    authorization: 'authorization-text',
  };
  private PDFDownDisabled = true;
  private mounted() {
    this.user = storage.get('user');
    if (this.user) {
      checkLogin();
      console.log('please login');
    } else {
     this.$router.push({
        path: '/login',
      });
    }
  }
  private PDFChange(info: any) {
    checkLogin();
    if (info.file.status !== 'uploading') {
      // console.log(info.file, info.fileList);
    }
    if (info.file.status === 'done') {
      this.$message.success(`${info.file.name} file uploaded successfully`);
      this.dataJson.PDFPath = info.file.response.path;
      this.dataJson.team = this.user.team;
      this.PDFDownDisabled = false;
      // console.log(this.dataJson);
    } else if (info.file.status === 'error') {
      this.$message.error(`${info.file.name} file upload failed.`);
    }
  }
  private downloadPDFClick() {
    this.spinning = true;
    const that = this;
    const args = {
      dataJson: this.dataJson,
    };
    this.axios.post('/api/getZKDPDFZip', args, { responseType: 'blob'}).then((res) => {
      let name = '';
      // console.log(res);
      try {
        name = res.headers['content-disposition'].split('filename="')[1];
        name = name.substring(0, name.length - 1);
      } catch ( err ) {
        console.log(err);
        name = 'noName.zip';
      }
      that.downloadFile(res.data, name);
    });
  }
  // 下载PDF 模板
  private getPDFTemplate() {
    this.spinning = true;
    const that = this;
    const args = {};
    this.axios.post('/api/getPDFTemplate', args , { responseType: 'blob'}).then((res) => {
      that.downloadFile(res.data, 'PDFTemplate.csv');
      // 清除上传记录
      // that.txtFileArr.splice(0, that.txtFileArr.length);
    });
  }
  // 下载文件 方法 传入blob数据,和 定义的文件名称
  private downloadFile(data: any, fileName: any) {
    if (!data) {
      return;
    }
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    // 获取文件名
    // download 属性定义了下载链接的地址而不是跳转路径
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    this.spinning = false;
  }
}

